'use client';

import { useEffect, useState } from 'react';
import {
  dismissSessionChangeRefusal,
  onSessionChangeRefusal,
  sessionChangeRefusal,
} from '@sourcepilot/ui/framework/data/session-change-refusal';

/** A session change the server refused, in its own words, at the top of
 *  the page (session-change-refusal.ts). */
export function SessionChangeNotice() {
  const [refusal, setRefusal] = useState(() => sessionChangeRefusal());
  useEffect(() => {
    setRefusal(sessionChangeRefusal());
    return onSessionChangeRefusal(() => setRefusal(sessionChangeRefusal()));
  }, []);
  if (!refusal) return null;
  return (
    <div role="alert" data-testid="session-change-refused" data-code={refusal.code}
      className="flex items-center justify-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      <span>{refusal.reason}</span>
      <button className="rounded border border-amber-300 bg-white px-2 py-0.5 text-xs hover:bg-amber-100"
        onClick={dismissSessionChangeRefusal} data-testid="session-change-refused-dismiss">
        Dismiss
      </button>
    </div>
  );
}
